import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_STARTER_ONBOARDING_TOGGLE = defineFcm('starfish_starter_onboarding_toggle')
	.asBoolean()
	.withDefault(false)
	.toConfig();
